import { SafeHtml } from "@angular/platform-browser";
import { BaseModel } from "./base";
import { Asset } from "./document";
import { Account } from "./user";
import { minAsset } from "app/layout/common/notifications/notifications.types";

export class CopilotMessageUI {
  id: string = null; // Unique ID for the message
  sender: 'copilot' | 'user' = 'user';
  message: SafeHtml = '';
  messageText: string = '';
  timestamp: string = new Date().toISOString();
  profilePicture: string = 'assets/images/avatars/profile.jpg';
  details: CitationDetail[] = [];
  exportOptions:string = null;
  exporting?: boolean = false; // ui state
}

export class MessageResponse extends BaseModel {
  id: string;
  account?: Account;
  role: string;
  content: string;
  details: CitationDetail[];
  exportOptions:string = null;
  sessionName: string = null;
}

export class CitationDetail extends BaseModel {
  account?: Account;
  documentName: string;
  content: string;
  pageNumbers:string;
}
export class Session extends BaseModel {
  account?: Account;
  sessionName: string;
  messages?: any;
  chatAssets: ChatAsset[];
  assistantAgentId:string = null;
}

export class ChatAsset extends BaseModel {
  account?: Account;
  asset: Asset;
  type: string;
}

export class CopilotSettings {
  ragEnabled: boolean = null;
  assistants: Assistant[] = [];
  agents: Agent[] = [];
}
export class Assistant {
  id: string;
  name: string;
  code: string;
  icon : string;
  description: string;
  ragAssistantId: string;
  enabled: boolean;
  assistantType:'Task' | 'QA' = null;
  defaultUserMessage : string;
  folderEnabled : boolean = false;
  exportOption : boolean = false;

  constructor(assitantType:'Task' | 'QA' = null){
      this.assistantType = assitantType = null;
      this.id = null;
      this.name = null;
      this.code = null;
      this.description = null;
      this.ragAssistantId = null;
      this.enabled = null;
      this.icon = null;
      this.defaultUserMessage = null;
  }
}

export class Agent {
  id: string = null;
  name: string = null;
  code: string = null;
  icon : string = null;
  description: string = null;
  ragAgentId: string = null;
  enabled: boolean = null;
  agentType :'Task' | 'QA' = null;
  folderEnabled : boolean = false;
  defaultUserMessage : string = null;
  agentSystem :'RAG' | 'N8N' = null;
  exportOption : boolean = false;

}

export class DataStructure {
  id: string = null;
  name: string = null;
  description: string = null;
  dataStruct: string = null;
  icon: string = null;
  form: string = null;
}

export class CopilotSuggestedUiPrompt{
      title:string = null;
      description: string = null;
      icon: string = null;
      color: string = null;
      rag_code:string = null;
}

export class SessionListItem{
    id: string;
    account?: any;
    createdBy?: any;
    updatedBy?: any;
    createdDate?: any;
    updatedDate?: any;
    deleted: boolean;
    ragAssistantId: string;
    sessionName: string;
    messages?: any;

}

export class CopilotAssetDetails extends minAsset{
  lpmReference: string = null;
  parsingPercentage: number = null;
  parsingProgress: 'Completed' | 'InProgress' | 'Pending' = null;
  ragScopedAssets:number = null;
  thumbnailUrl:string = null;
}